import { useFeatureFlag } from '@bonusly/who-am-i';

export enum Variant {
	OneOnOnesEarlyAccess = 'one-on-ones',
	OneOnOnesLimitedRelease = 'achieve-limited-release',
}

/**
 * @deprecated Prefer `useFeatureFlag` from `@bonusly/who-am-i` instead.
 */
export const useVariantEnabled = useFeatureFlag;
